/* ONLY CHASES · La mira — interacción */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Carta holo: sigue al puntero */
  document.querySelectorAll('[data-oc-stage]').forEach(function (stage) {
    var holo = stage.querySelector('.oc-holo');
    var foil = stage.querySelector('.oc-holo__foil');
    if (!holo) return;
    function paint(x, y, on) {
      holo.classList.toggle('is-live', on);
      holo.style.transition = on ? 'transform .08s linear' : '';
      holo.style.transform = on ? 'rotateX(' + ((0.5 - y) * 22).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 26).toFixed(2) + 'deg) scale(1.02)' : '';
      holo.style.setProperty('--oc-gx', (x * 100).toFixed(1) + '%');
      holo.style.setProperty('--oc-gy', (y * 100).toFixed(1) + '%');
      if (foil && on) {
        var a = 110 + x * 40, p = x * 20;
        foil.style.backgroundImage = 'linear-gradient(' + a + 'deg, transparent 10%, rgba(255,90,180,.55) ' + (25 + p) + '%, rgba(120,220,255,.55) ' + (40 + p) + '%, rgba(150,255,170,.5) ' + (55 + p) + '%, rgba(255,240,120,.45) ' + (68 + p) + '%, transparent 90%)';
      } else if (foil) { foil.style.backgroundImage = ''; }
    }
    stage.addEventListener('pointermove', function (e) {
      if (reduce) return;
      var r = holo.getBoundingClientRect();
      paint(Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)), Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)), true);
    });
    stage.addEventListener('pointerleave', function () { paint(0.5, 0.5, false); });
  });

  /* Filtro de la parrilla de portada */
  document.querySelectorAll('[data-oc-filters]').forEach(function (box) {
    var grid = document.getElementById(box.getAttribute('data-oc-filters'));
    if (!grid) return;
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-f]');
      if (!b) return;
      box.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
      var f = b.getAttribute('data-f');
      grid.querySelectorAll('.oc-card').forEach(function (c) { c.hidden = f !== 'all' && c.getAttribute('data-game') !== f; });
    });
  });

  /* Galería de la ficha */
  document.querySelectorAll('[data-oc-gallery]').forEach(function (g) {
    var alt = g.querySelector('.oc-gallery__alt img');
    g.querySelectorAll('.oc-thumb').forEach(function (t, i) {
      t.addEventListener('click', function () {
        g.querySelectorAll('.oc-thumb').forEach(function (x) { x.classList.toggle('is-on', x === t); });
        if (i === 0) { g.classList.remove('is-alt'); return; }
        alt.src = t.getAttribute('data-src');
        alt.alt = t.getAttribute('data-alt') || '';
        g.classList.add('is-alt');
      });
    });
  });

  /* Cantidad */
  document.querySelectorAll('[data-oc-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-step]');
      if (!b) return;
      e.preventDefault();
      var max = parseInt(input.getAttribute('max') || '999', 10);
      var v = Math.min(max, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10)));
      input.value = v;
    });
  });

  /* Barra fija de compra en móvil */
  var bar = document.querySelector('[data-oc-buybar]');
  var target = document.querySelector('[data-oc-buy-target]');
  if (bar && target && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { bar.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(target);
    bar.querySelector('button').addEventListener('click', function () { var b = target.querySelector('button[type=submit]'); if (b) b.click(); });
  }

  /* Colección: filtros y orden */
  document.querySelectorAll('[data-oc-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type=checkbox]')) form.submit();
    });
  });
  document.querySelectorAll('[data-oc-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });
  document.querySelectorAll('[data-oc-toggle-filters]').forEach(function (b) {
    b.addEventListener('click', function () {
      var c = document.querySelector('.oc-coll');
      if (c) { c.classList.toggle('is-filtering'); b.setAttribute('aria-expanded', c.classList.contains('is-filtering')); }
    });
  });
})();